import { Button, DraggableVideo } from 'components'
import { usePathname } from 'hooks'
import React, { useMemo } from 'react'
import { DraggableData, DraggableEvent } from 'react-draggable'
import ReactPlayer from 'react-player'
import { useDispatch } from 'react-redux'
import { setIsLmsSidebarOpen, useLMS } from 'state'

import { HamburgerMenuIcon, VideoIcon } from '@radix-ui/react-icons'

import { useLMSVideoContext } from '../context/lmsVideo.context'

type VideoSectionType = {
  title?: string
  isShowMenu?: boolean
}

const VideoSection = (props: VideoSectionType) => {
  const { title, isShowMenu = true } = props
  const { lmsVideoUrl, isLmsSidebarOpen } = useLMS()
  const { isLms } = usePathname()

  const {
    timeStampRef,
    playerRef,
    syncVideoTimeStamp,
    draggableVideoPostion,
    syncDraggableVideoPostion,
    isLmsTheaterMode,
    handleToggleLmsTheaterMode
  } = useLMSVideoContext()
  const dispatch = useDispatch()

  const RenderPlayer = useMemo(() => {
    return (
      <ReactPlayer
        onReady={() => syncVideoTimeStamp()}
        playing={true}
        ref={playerRef}
        url={lmsVideoUrl || ''}
        height="100%"
        width="100%"
        controls
        onProgress={(state) => (timeStampRef.current = state.playedSeconds)}
      />
    )
  }, [lmsVideoUrl, playerRef, syncVideoTimeStamp, timeStampRef])

  const handleOnDrag = ({
    _e,
    _data
  }: {
    _e: DraggableEvent
    _data: DraggableData
  }) => {
    syncDraggableVideoPostion({
      x: _data.lastX + _data.deltaX,
      y: _data.lastY + _data.deltaY
    })
  }

  if (!isLms || !lmsVideoUrl) {
    return null
  }

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          {isShowMenu ? (
            <div>
              <Button
                variant="transparent"
                className="ml-1 mr-2"
                onClick={() => {
                  dispatch(setIsLmsSidebarOpen(!isLmsSidebarOpen))
                }}>
                <HamburgerMenuIcon className="h-5 w-5" />
              </Button>
            </div>
          ) : null}
          <h1 className="text-2xl font-bold capitalize">{title}</h1>
        </div>
        {isLmsTheaterMode && lmsVideoUrl && (
          <Button
            variant="transparent"
            className="mx-2"
            onClick={handleToggleLmsTheaterMode}>
            <VideoIcon className="h-5 w-5" />
          </Button>
        )}
      </div>

      {!isLmsTheaterMode && lmsVideoUrl && (
        <DraggableVideo
          position={draggableVideoPostion}
          handleOnDrag={handleOnDrag}>
          {RenderPlayer}
        </DraggableVideo>
      )}

      {lmsVideoUrl && (
        <div className="py-1">
          {isLmsTheaterMode ? (
            <div className="h-[35vh]">{RenderPlayer}</div>
          ) : (
            <div
              className="flex justify-center items-center bg-zinc-800 p-3 rounded-md cursor-pointer"
              onClick={handleToggleLmsTheaterMode}>
              Pop back the video
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default VideoSection
